module.exports = __webpack_public_path__ + "img/greyscale_logo.5f1fa020.svg";